/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationF2fAttestation } from './HomeHealthCertificationF2fAttestation';
import {
    HomeHealthCertificationF2fAttestationFromJSON,
    HomeHealthCertificationF2fAttestationFromJSONTyped,
    HomeHealthCertificationF2fAttestationToJSON,
    HomeHealthCertificationF2fAttestationToJSONTyped,
} from './HomeHealthCertificationF2fAttestation';
import type { HomeHealthCertificationCriteriaF2fEncounterNote } from './HomeHealthCertificationCriteriaF2fEncounterNote';
import {
    HomeHealthCertificationCriteriaF2fEncounterNoteFromJSON,
    HomeHealthCertificationCriteriaF2fEncounterNoteFromJSONTyped,
    HomeHealthCertificationCriteriaF2fEncounterNoteToJSON,
    HomeHealthCertificationCriteriaF2fEncounterNoteToJSONTyped,
} from './HomeHealthCertificationCriteriaF2fEncounterNote';
import type { HomeHealthCertificationReviewReason } from './HomeHealthCertificationReviewReason';
import {
    HomeHealthCertificationReviewReasonFromJSON,
    HomeHealthCertificationReviewReasonFromJSONTyped,
    HomeHealthCertificationReviewReasonToJSON,
    HomeHealthCertificationReviewReasonToJSONTyped,
} from './HomeHealthCertificationReviewReason';

/**
 * 
 * @export
 * @interface HomeHealthCertificationCriteriaF2f
 */
export interface HomeHealthCertificationCriteriaF2f {
    /**
     * 
     * @type {HomeHealthCertificationStatus}
     * @memberof HomeHealthCertificationCriteriaF2f
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     * @type {Array<HomeHealthCertificationReviewReason>}
     * @memberof HomeHealthCertificationCriteriaF2f
     */
    review_reasons: Array<HomeHealthCertificationReviewReason>;
    /**
     * 
     * @type {HomeHealthCertificationF2fAttestation}
     * @memberof HomeHealthCertificationCriteriaF2f
     */
    attestation: HomeHealthCertificationF2fAttestation;
    /**
     * 
     * @type {HomeHealthCertificationCriteriaF2fEncounterNote}
     * @memberof HomeHealthCertificationCriteriaF2f
     */
    encounter_note: HomeHealthCertificationCriteriaF2fEncounterNote;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationCriteriaF2f
     */
    attestation_match: HomeHealthCertificationCriteriaF2fAttestationMatchEnum;
}


/**
 * @export
 */
export const HomeHealthCertificationCriteriaF2fAttestationMatchEnum = {
    ExactDate: 'exact_date',
    DifferentDate: 'different_date',
    EncounterNotFound: 'encounter_not_found',
    AttestationNotFound: 'attestation_not_found',
    NeedsReview: 'needs_review'
} as const;
export type HomeHealthCertificationCriteriaF2fAttestationMatchEnum = typeof HomeHealthCertificationCriteriaF2fAttestationMatchEnum[keyof typeof HomeHealthCertificationCriteriaF2fAttestationMatchEnum];


/**
 * Check if a given object implements the HomeHealthCertificationCriteriaF2f interface.
 */
export function instanceOfHomeHealthCertificationCriteriaF2f(value: object): value is HomeHealthCertificationCriteriaF2f {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('review_reasons' in value) || value['review_reasons'] === undefined) return false;
    if (!('attestation' in value) || value['attestation'] === undefined) return false;
    if (!('encounter_note' in value) || value['encounter_note'] === undefined) return false;
    if (!('attestation_match' in value) || value['attestation_match'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationCriteriaF2fFromJSON(json: any): HomeHealthCertificationCriteriaF2f {
    return HomeHealthCertificationCriteriaF2fFromJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaF2fFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationCriteriaF2f {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'review_reasons': ((json['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonFromJSON)),
        'attestation': HomeHealthCertificationF2fAttestationFromJSON(json['attestation']),
        'encounter_note': HomeHealthCertificationCriteriaF2fEncounterNoteFromJSON(json['encounter_note']),
        'attestation_match': json['attestation_match'],
    };
}

export function HomeHealthCertificationCriteriaF2fToJSON(json: any): HomeHealthCertificationCriteriaF2f {
    return HomeHealthCertificationCriteriaF2fToJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaF2fToJSONTyped(value?: HomeHealthCertificationCriteriaF2f | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'review_reasons': ((value['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonToJSON)),
        'attestation': HomeHealthCertificationF2fAttestationToJSON(value['attestation']),
        'encounter_note': HomeHealthCertificationCriteriaF2fEncounterNoteToJSON(value['encounter_note']),
        'attestation_match': value['attestation_match'],
    };
}

